import { defineNuxtPlugin } from '#app'

import { createClient } from 'contentful'

export default defineNuxtPlugin(nuxtApp => {
  const config = useRuntimeConfig()
  const client = createClient({
    space: config.public.CTF_SPACE_ID,
    environment: config.public.CTF_SPACE_ENV,

    ...(config.public.CTF_PREVIEW_MODE === 'true'
      ? {
          host: 'preview.contentful.com',
          accessToken: config.public.CTF_CDA_PREVIEW_ACCESS_TOKEN,
        }
      : {
          accessToken: config.public.CTF_CDA_ACCESS_TOKEN,
        }),
  })

  const actClient = createClient({
    space: config.public.CTF_ACT_SPACE_ID,
    environment: 'master',
    accessToken: config.public.CTF_ACT_CDA_ACCESS_TOKEN,
  })

  nuxtApp.provide('contentful', client)
  nuxtApp.provide('contentfulAct', actClient)
})
